import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { InputFieldComponent } from '../../ui/inputField/inputField.component';
import { CustomizableButtonComponent } from '../../ui/customizable-button/customizable-button.component';
import { ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';

// services
import { ContactsService } from '../../../services/contacts/contacts.service';
import { ITag } from '../../../types/contactModule';

@Component({
  selector: 'create-tag-form-modal',
  standalone: true,
  imports: [ModalFormContainerComponent, InputFieldComponent, CustomizableButtonComponent, ReactiveFormsModule],
  templateUrl: './create-tag-form-modal.component.html',
  styleUrls: ['../../tables/group-table/group-form.css', './create-tag-form-modal.component.css'],
})
export class CreateTagFormModalComponent {
  @Output() closeModal = new EventEmitter();

  // reactive data
  submitted: boolean = false;
  saveError = '';

  // services
  contactsService = inject(ContactsService);
  builder = inject(FormBuilder);

  tagForm = this.builder.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: [''],
  });

  get nameError(): string {
    const control = this.tagForm.controls.name;
    if (!this.submitted || control.valid) return '';
    return control.hasError('required') ? 'Enter a name for the tag' : 'Use at least 2 characters';
  }

  close() {
    this.closeModal.emit();
  }

  get contactServiceLoading() {
    return this.contactsService.isLoading;
  }

  handleSubmit() {
    this.submitted = true;
    this.saveError = '';
    if (this.tagForm.valid) {
      this.contactsService.createTag(this.tagForm.value as ITag).subscribe({
        next: () => {
          this.close();
        },
        error: () => {
          this.saveError = 'The tag was not created. Check your connection and try again.';
        },
      });
    }
  }
}
